<template>
    <b-form-group
            :id="'input-group-' + index"
            :label="label"
            :label-for="'input-' + index">
        <b-input-group>
            <b-form-input
                    :class="(error.length > 0) ? 'is-invalid' : ''"
                    :id="'input-' + index"
                    v-model="input"
                    type="text"
                    :state="state"
                    :required="required"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    @input="run"
                    autocomplete="off">
            </b-form-input>
            <b-input-group-text slot="append">
                <font-awesome-icon :icon="['fal', 'check']" class="text-success" v-if="check"/>
                <font-awesome-icon :icon="['fal', 'times']" class="text-danger" v-else/>
            </b-input-group-text>
        </b-input-group>
        <b-form-invalid-feedback id="input-1-live-feedback">
            Rut Inválido
        </b-form-invalid-feedback>
        <div v-if="error.length > 0">
            <p class="text-danger" v-for="(e,key) in error" v-bind:key="key">{{ e }}</p>
        </div>
    </b-form-group>
</template>

<script>
    export default {
        name: "input-rut",
        props: {
            index: {type: Number, default: 1},
            placeholder: {type: String, default: ''},
            label: {type: String, default: ''},
            cols: {type: String, default: ''},
            sm: {type: String, default: ''},
            md: {type: String, default: ''},
            lg: {type: String, default: ''},
            xl: {type: String, default: ''},
            offset: {type: String, default: ''},
            disabled: {type: Boolean, default: false},
            value: {default: null},
            required: {type: Boolean, default: false},
            error: {type: Array, default: () => []},
            state: {default: null},
            v: {default: null},
        },
        watch: {
            value(event) {
                this.input = event;
            },
            input() {
                this.handleInput();
            },
            check() {
            }
        },
        data() {
            return {
                input: '',
                dv: null,
                rut: '',
                check: false
            }
        },
        mounted() {
            this.input = this.value;
        },
        methods: {
            digito(rut, dv) {
                let suma = 0;
                let multiplicador = 2;
                while (rut !== 0) {
                    if (multiplicador === 8) {
                        multiplicador = 2;
                    }
                    suma += (rut % 10) * multiplicador;
                    rut = Math.trunc(rut / 10);
                    multiplicador++;
                }
                suma = 11 - (suma % 11);
                switch (suma) {
                    case 11:
                        this.check = ("0" === dv);
                        break;
                    case 10:
                        this.check = ("K" === dv.toUpperCase());
                        break;
                    default:
                        this.check = (suma.toString() === dv);
                        break;
                }
            },
            quitarformato() {
                this.input = this.input.replace(/[^\dKk]/g, '');
                let dato = this.input;
                let largo = dato.length;
                if (largo === 1) {
                    this.dv = dato;
                    this.rut = '';
                    this.digito(this.rut, this.dv);
                    this.formato()
                } else if (largo > 1) {
                    this.dv = dato.substring(largo - 1);
                    this.rut = dato.substring(largo - 1, 0);
                    this.digito(this.rut, this.dv);
                    this.formato()
                }
            },
            formato() {
                let rut = (this.rut) ? (new Intl.NumberFormat("es-CL").format(parseInt(this.rut))) + '-' : '';
                this.input = rut + this.dv;
            },
            run() {
                this.quitarformato();
                this.handleInput();
            },
            handleInput() {
                this.$emit('update:error', []);
                this.$emit('input', this.input)
            }
        }
    }
</script>

<style scoped>

</style>
